import classNames from 'classnames';
import { Flex } from 'antd';
import { ViewResolver } from '@Components/ViewResolver';
import { ReactComponent as SearchIcon } from '@Icons/additional/search-gradient.svg';
import { ReactComponent as ImportIcon } from '@Icons/additional/download-gradient.svg';

import styles from './material-confirmation-tabs.module.css';

const TenderConfirmationActions: React.FC = () => {
  return (
    <Flex gap={16}>
      <ViewResolver
        desktop={
          <>
            <div
              className={classNames(
                'trojan-neumorphism-box trojan-neumorphism-box-shadow',
                styles.actionBox
              )}
            >
              <ImportIcon />
            </div>
            <div
              className={classNames(
                'trojan-neumorphism-box trojan-neumorphism-box-shadow',
                styles.actionBox
              )}
            >
              <SearchIcon />
            </div>
          </>
        }
        mobile={null}
      />
    </Flex>
  );
};

export default TenderConfirmationActions;
